<header class="header">
  <div class="header-left">
    <div class="header-brand">
      <div class="header-logo">
        <img src="assets/images/abc_logo.png" alt="" srcset="" />
      </div>
    </div>
  </div>
  <div class="header-center">
    <span
      class="radio-group"
      style="display: inline-flex; align-items: center"
      [class.mobile-radio-group]="isBelowIpadSize"
    >
      <!-- Radio: Private -->
      <div class="radio">
        <input
          type="radio"
          id="private"
          value="private"
          name="queryType"
          [checked]="assistBotService.queryType['library']"
          (change)="changeQuery($event)"
          style="margin-right: 5px"
        />
        <label
          id="private-label"
          for="private"
          style="margin-right: 15px"
          class="radio-label"
          ><a
            class="has-tooltip-left"
            data-tooltip="Responses Will Be Based On The Document"
            data-bs-placement="left"
            data-bs-title="Tooltip on left"
            placement="left"
            >Private</a
          ></label
        >
      </div>
      <div class="radio">
        <input
          type="radio"
          id="generic"
          value="generic"
          name="queryType"
          [checked]="!assistBotService.queryType['library']"
          (change)="changeQuery($event)"
          style="margin-right: 5px"
        />
        <label id="generic-label" for="generic" class="radio-label"
          ><a
            class="has-tooltip-left"
            data-tooltip="Responses Will Be Based On Data That Is Accessible To The Public"
            data-bs-placement="left"
            data-bs-title="Tooltip on left"
            class="has-tooltip-left"
            placement="left"
            >Generic</a
          ></label
        >
      </div>
      <!-- Radio: Generic -->
    </span>
  </div>
  <div class="header-right">
    <button
      class="icon-btn"
      pTooltip="New Conversation"
      showDelay="1000"
      hideDelay="300"
      (click)="onClickStartConversation()"
    >
      <i class="pi pi-refresh"></i>
    </button>
    <button
      class="icon-btn"
      pTooltip="History"
      showDelay="1000"
      hideDelay="300"
      (click)="toggleHistory()"
    >
      <i class="pi pi-history"></i>
    </button>
  </div>
</header>

<div class="main">
  @if (chatData?.length > 0) {

  <!-- Chat messages -->
  <div
    #chatContainer
    class="chat-list msg-list-view"
    appInfiniteScroll
    (reachedTop)="onScrollUp($event)"
    (scroll)="onScroll()"
  >
    @for (item of chatData; track trackByFn(i, item); let i = $index) {
    <app-chat-bot
      #aiComponent
      [data]="item"
      [index]="i"
      [historyItem]="selectedItem"
      [active]="item.sequence_id === selectedItem?.sequence_id"
    ></app-chat-bot>
    }
  </div>

  } @else {

  <div class="welcome-banner">
    <div class="welcome-content">
      <h2>Hi ABC, welcome to <strong>Absence Assistance</strong></h2>

      <p>
        I'll help you with questions and answers on the State and Company
        policies.
      </p>
    </div>

    <div class="abs-area">
      <div class="abs-chips">
        <button class="abs-chips-btn">
          <i class="pi pi-map-marker"></i>

          <span>
            Select Work State,
            <i class="pi pi-briefcase"></i>
            Leave Reason,
            <i class="pi pi-briefcase"></i>
            Company
          </span>
        </button>
      </div>
    </div>
  </div>

  }

  <div class="chat-input-wrapper">
    <div class="chat-input-container">
      <!-- INPUT -->
      <div class="input-area">
        <input
          type="text"
          #autoCompleteInput
          placeholder="Ask about your Policy related queries..."
          [(ngModel)]="queryInputValue"
          (keyup.enter)="onKeyPressEvent($event)"
        />
      </div>

      <!-- ACTIONS -->
      <div class="actions">
        @if (!activeVoiceOver) {

        <button
          class="icon-btn mic"
          (click)="startVoiceRecognition()"
          title="Dictate"
        >
          <img src="assets/images/ai-agentic/mic.png" />
        </button>

        <button
          class="icon-btn call"
          [routerLink]="['/bot-voice']"
          title="Voice mode"
        >
          <img src="assets/images/ai-agentic/calling.png" />
        </button>

        <button
          class="send-btn"
          [disabled]="!queryInputValue?.trim()"
          [class.active]="queryInputValue?.trim()"
          (click)="submitQuestion()"
        >
          <i class="pi pi-send"></i>
        </button>

        } @else {

        <button class="icon-btn stop" (click)="stopVoiceRecord()">
          <img src="assets/images/ai-agentic/close.png" />
        </button>

        <button
          class="send-btn"
          [disabled]="!queryInputValue?.trim()"
          [class.active]="queryInputValue?.trim()"
          (click)="submitQuestion()"
        >
          <i class="pi pi-send"></i>
        </button>

        }
      </div>
    </div>
    <p class="input-hint">
      <i class="pi pi-info-circle"></i> Press <kbd>Enter</kbd> to send ·
      <kbd>Shift+Enter</kbd> for new line
    </p>
  </div>
</div>
<!-- Overlay -->
@if (showHistory) {
<div class="overlay" (click)="closeHistory()"></div>
}

<!-- Right Side History Panel -->
<div class="history-panel" [class.open]="showHistory">
  <div class="panel-header">
    <h3>History</h3>

    <button class="close-btn" (click)="closeHistory()">✕</button>
  </div>

  <div class="history-list">
    @for (item of historyList; track item) {
    <div class="history-item">
      <div class="title">{{ item.title }}</div>
      <!-- <div class="date">{{ item.date }}</div> -->
    </div>
    }
  </div>
</div>
